import { PdfAreaDontBreak, PdfGridsArea, PdfH2, PdfTable } from 'pages/v2/compiler/PDF/Styles.styled';
import { useGetEpdDataQualityAssessment } from 'services/api/queries';

import DataQualityAssessmentAndReferenceYearsGridPdf from './DataQualityAssessmentAndReferenceYearsGridPdf';
import usePcrV2 from '../../hooks/usePcrV2';
import { isArraySingleEmptyValue } from 'util/utils';

type TProps = {
  epdVersionId: string;
};

const DataQualityAssessmentAndReferenceYearsPdf = ({ epdVersionId }: TProps) => {
  const isPcrV2 = usePcrV2();
  const dataQuality = useGetEpdDataQualityAssessment(epdVersionId).data;

  // #11472. The users visually can't to figure out whether the empty row is added by default or they forgot to delete empty row, which was added by them before.
  // So it is needed to hide the table if the single entity with empty fields is existed.
  const isOnlySingleEmptyRow =
    dataQuality?.dataQualityAssessmentItems && isArraySingleEmptyValue(dataQuality.dataQualityAssessmentItems);

  const anyRows =
    dataQuality?.dataQualityAssessmentItems && dataQuality.dataQualityAssessmentItems.length > 0 && !isOnlySingleEmptyRow;

  const summaryExists =
    !!dataQuality?.dataQualityAssessmentSummary &&
    (!!dataQuality.dataQualityAssessmentSummary.dataQualityAssessmentSummary ||
      !!dataQuality.dataQualityAssessmentSummary.dataQualityAssessmentComment);

  if (!anyRows && !summaryExists) {
    return null;
  }

  return (
    <PdfAreaDontBreak>
      <PdfH2>{isPcrV2 ? 'Data quality assessment' : 'Data quality assessment and reference years'}</PdfH2>
      <PdfGridsArea>
        <PdfTable>
          <thead>
            <tr>
              <th style={{ width: '30%' }}></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dataQuality?.dataQualityAssessmentSummary?.dataQualityAssessmentSummary && (
              <tr>
                <td>Description of data quality assessment and reference years</td>
                <td>{dataQuality?.dataQualityAssessmentSummary?.dataQualityAssessmentSummary}</td>
              </tr>
            )}
          </tbody>
        </PdfTable>
        {anyRows && (
          <DataQualityAssessmentAndReferenceYearsGridPdf
            dataQualityAssessmentItems={dataQuality?.dataQualityAssessmentItems}
          />
        )}
        {isPcrV2 && dataQuality?.dataQualityAssessmentSummary?.dataQualityAssessmentComment && (
          <PdfTable>
            <thead>
              <tr>
                <th style={{ width: '30%' }}></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Comment on the data sources and other information in the table</td>
                <td>{dataQuality?.dataQualityAssessmentSummary?.dataQualityAssessmentComment}</td>
              </tr>
            </tbody>
          </PdfTable>
        )}
      </PdfGridsArea>
    </PdfAreaDontBreak>
  );
};

export default DataQualityAssessmentAndReferenceYearsPdf;
